import { render, staticRenderFns } from "./DecisionListTable.vue?vue&type=template&id=ca828138&"
import script from "./DecisionListTable.vue?vue&type=script&lang=js&"
export * from "./DecisionListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports